import { createSlice } from "@reduxjs/toolkit";
import { GET_Unit_Data } from "./thunk";

const UnitSlice = createSlice({
    name: "Unit",
    initialState: {
        loading: false,
        error: null,
        success: false,
        data: [], // Changed from `null` to an empty array for safer access
    },
    reducers: {
        resetState: (state) => {
            Object.assign(state, { loading: false, error: null, success: false, data: [] });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_Unit_Data.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(GET_Unit_Data.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload || []; // Ensure data is always an array
            })
            .addCase(GET_Unit_Data.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "An error occurred";
            });
    },
});

export const { resetState } = UnitSlice.actions;
export default UnitSlice.reducer;
